import { Injectable } from '@angular/core';
@Injectable()
export class Common {

    public month: any[] = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
    constructor() { }
    // return date YY-MM-DD
    public getDateYYMMDD(date: any) {
        if (date) {
            return date.year + "-" + date.month + "-" + date.day;
        }
        return null;
    }

    // return date time with set 0 0 0 0 hours and time
    public getTime(date: any) {
        let tempDate = new Date(date);
        tempDate.setHours(0, 0, 0, 0);
        return tempDate.getTime();
    }

    //returning date array like 1-JAN, 2-Feb from between dates
    public getDateArray(start, end) {
        let arr = [];
        let dt = new Date(start);
        while (dt <= end) {
            let date = new Date(dt)
            if (6 > date.getDay() && date.getDay() != 0) {
                arr.push(Number(date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear());
            }
            dt.setDate(dt.getDate() + 1);
        }
        return arr;
    }

    // return date MM/DD/YYYY
    public getDateDDMMYY(date: any) {
        if (date) {
            date = new Date(date);
            return Number(date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();
        }
        return "";
    }

    // return date YY-MM-DD
    public getDatesYYMMDD(date: any) {
        if (date) {
            date = new Date(date);
            return date.getFullYear() + "-" + Number(date.getMonth() + 1) + "-" + date.getDate();
        }
        return "";
    }
    // get
    public getJSONObj(date) {
        if (date) {
            date = new Date(date);
            return { year: date.getFullYear(), month: Number(date.getMonth() + 1), day: date.getDate() };
        }
        return;
    }

    //Validate two dates are equals or not
    public compareTwoDates(bookingdate, calDate) {
        let compareToDate = new Date(bookingdate);
        compareToDate.setHours(0, 0, 0, 0);
        let compareFromDate = new Date(calDate);
        compareFromDate.setHours(0, 0, 0, 0);
        if (compareToDate.getTime() == compareFromDate.getTime()) {
            return true;
        }
        return false;
    }

    //get date time of long value
    public getDateTime(tempDate) {
        let date = new Date(tempDate);
        date.setHours(0, 0, 0, 0)
        return date.getTime();
    }

    //returning date array like 1-JAN, 2-Feb from between dates
    public getMonthsNameArray(start, end) {

        let arr = [];
        let dt = new Date(start);
        while (dt <= end) {
            let date = new Date(dt)
            arr.push(this.month[date.getMonth()] + "-" + date.getFullYear());
            dt.setMonth(dt.getMonth() + 1);
        }

        return arr;
    }

    // returning date like 1-JAN from dates
    public getMonthsName(date) {
        let dt = new Date(date);
        return this.month[dt.getMonth()] + "-" + dt.getFullYear();
    }

    public isSuperUser() {
        return JSON.parse(localStorage.getItem("user")).userData.userRoll === "1";
    }

    /* takes a string phrase and breaks it into separate phrases 
   no bigger than 'maxLength', breaks are made at complete words.*/

    // public breakAllSentencesInLines(stringArr, maxLength) {
    //     var splittedArrays = [];
    //     var that = this;
    //     stringArr.forEach(function(str, index){
    //         splittedArrays[index] = that.breakSentenceInLines(str, maxLength);
    //     });
    //     return splittedArrays;
    // }

    // public breakSentenceInLines(str, maxLength){
    //     var sections = [];
    //     var words = str.split(" ");
    //     var temp = "";

    //     words.forEach(function(item, index){
    //         if(temp.length > 0)
    //         {
    //             var concat = temp + ' ' + item;

    //             if(concat.length > maxLength){
    //                 sections.push(temp);
    //                 temp = "";
    //             }
    //             else{
    //                 if(index == (words.length-1))
    //                 {
    //                     sections.push(concat);
    //                     return;
    //                 }
    //                 else{
    //                     temp = concat;
    //                     return;
    //                 }
    //             }
    //         }

    //         if(index == (words.length-1))
    //         {
    //             sections.push(item);
    //             return;
    //         }

    //         if(item.length < maxLength) {
    //             temp = item;
    //         }
    //         else {
    //             sections.push(item);
    //         }

    //     });

    //     return sections;
    // }
}